/**
 * Year-logic registry (D13) — resolves the APP Plus business-logic module for
 * a program year. Exact match wins; otherwise the NEAREST PRIOR year's logic
 * applies (2027 data with inherited 2026 rules works until 2027's module
 * lands). Years before the first module throw — there are no rules to apply.
 */
import type { AppPlusYearLogic } from './types';
import { logic2026 } from './2026';

const YEAR_LOGIC: Record<number, AppPlusYearLogic> = {
  2026: logic2026,
};

export function logicForYear(year: number): AppPlusYearLogic {
  if (YEAR_LOGIC[year]) return YEAR_LOGIC[year];
  const prior = Object.keys(YEAR_LOGIC).map(Number).filter(y => y < year).sort((a, b) => b - a)[0];
  if (prior != null) return YEAR_LOGIC[prior];
  throw new Error(`No APP Plus logic module exists for ${year} (earliest is ${Math.min(...Object.keys(YEAR_LOGIC).map(Number))})`);
}

export const logicYears = () => Object.keys(YEAR_LOGIC).map(Number).sort();
